import React from 'react';

import { useTranslation } from '@crehana/i18n';

const TotalToPay: React.FC<{
  codeSymbol: string | null;
  price?: number | null;
  realPrice: number | null;
  className?: string;
  id?: string;
}> = ({ codeSymbol, price, className, id, realPrice }) => {
  const { t } = useTranslation();
  const hasDiscount = realPrice! > price!;
  const priceColor = hasDiscount ? 'text-red-main' : 'text-base-main';

  return (
    <React.Fragment>
      <h4 className={`flex items-baseline ${className}`} id={id}>
        <div className="flex flex-wrap w-full justify-between ">
          <p className="mr-12 font-subtitle1 ">{t('LONG_PAYMENT_TAG')}:</p>
          <p className="flex items-center">
            {hasDiscount && (
              <span className="line-through text-secondary-dark font-discount-s mr-8">
                {codeSymbol}
                {realPrice?.toLocaleString('en-US')}
              </span>
            )}
            <span className={`font-price ${priceColor} sm:hidden`}>
              <span data-testid="product-price-currency">{codeSymbol}</span>
              <span data-testid="product-price">
                {price?.toLocaleString('en-US')}
              </span>
            </span>
            <span className={`hidden sm:block font-price-s-md ${priceColor}`}>
              <span data-testid="product-price-currency">{codeSymbol}</span>
              <span data-testid="product-price">
                {price?.toLocaleString('en-US')}
              </span>
            </span>
          </p>
        </div>
      </h4>
    </React.Fragment>
  );
};

export default TotalToPay;
